module.exports = __webpack_public_path__ + "static/media/ic_download.81af89ec.svg";